export default {
  ACTIONS: Object.freeze({
    SIGN_OUT: "signOut",
    SET_TOKEN: "setToken",
    SET_USER_EMAILS: "setUserEmails",
    SUBMIT_EXAM: "submitExam",
    DELETE_SCORE_REPORT: "deleteScoreReport"
  }),
  GETTERS: Object.freeze({
    ACCESS: "getAccess",
    COURSE: "getCourse",
    COURSES: "getCourses",
    COURSE_NAMES: "getCourseNames",
    COURSE_OBJECTS: "getCourseObjects",
    IS_LOGGED_IN: "isLoggedIn",
    IS_ADMIN: "isAdmin",
    IS_STAFF: "isStaff",
    IS_STUDENT: "isStudent",
    USER: "getUser",
    USER_EMAILS: "getUserEmails",
    IS_SESSION_REPORT_DUE: "isSessionReportDue"
  })
};
